export default class Lazyload {
  constructor({lazyimages} = {}) {
    this.lazyimages = document.querySelectorAll(lazyimages);

    this.init();
  }

  init() {
    if (!this.lazyimages) return;
    [...this.lazyimages].map(i => this.loadImg(i));
  }

  loadImg(img) {
    if (!img.getAttribute('data-lazyimage')) return;

    let fakeImg = new Image();
    fakeImg.src = img.getAttribute('data-lazyimage');

    fakeImg.onload = () => {
      if (img.tagName === 'IMG') {
        img.setAttribute('src', fakeImg.src);
      }
      else {
        img.style.backgroundImage = `url(${fakeImg.src})`;
      }

      img.classList.add('is-loaded');
    }
  }
}

/*
Add attribute data-lazyimage=[image url] and class
'js-lazyimage' {transition: 1000ms; opacity: 0 &.is-loaded {opacity: 1}}
to the target element.
*/